import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  CARD_RULE_NOSHOWCINEMA: 0, // 判断如果是从支付列表的卡详情过来  卡规则页面则不需要显示“线下兑换影院 0为不显示“
  CARD_RULE_ISSHOWCINEMA: 1, // 判断如果是从支付列表的卡详情过来  卡规则页面则不需要显示“线下兑换影院 1为显示“
  CARD_CINEMAHISTORY_KEY: 'cinemaHistory',
  CARD_DETAIL_FROM_ENTERPRISE: 'enterprise_region',
  CARD_MAX_CINEMAHISTORY: 10,
  CARD_TYPE_TIME_CARD: 1, // 旧卖座次卡，
  CARD_TYPE_GIFT_CARD: 4, // 礼包卡，
  CARD_TYPE_SUDA_CARD: 3, // 普通苏打券，
  CARD_TYPE_VALUE_CARD: 2, // 旧卖座储值卡，

  CARD_QUERY_TYPE_QRCODE: 1, // 二维码查询
  CARD_QUERY_TYPE_PASSWORD: 2, // 券号密码查询
  CARD_QUERY_TYPE_UNIQ_CODE: 3, // 唯一码查询
  CARD_QUERY_TYPE_ELECTRONIC_CODE: 4, // 电子码查询

  // 卡面显示类型
  CARD_DETAIL_CARD: 2,   // 卡详情的卡面显示
  CARD_NORMAL_CARD_LIST: 1,   // 个人中心卡列表
  CARD_DEDUCTION_CARD_LIST: 3, // 抵扣卡列表

  BANNER_TYPE: 11, // 礼品卡详情运营推荐banner列表

  CARD_CATEGORY_FILE: 1, // 电影
  CARD_CATEGORY_RECHANGE: 2, // 充值
  CARD_CATEGORY_FRUIT: 3,  // 水果
  CARD_CATEGORY_BOOK: 4, // 图书
  CARD_CATEGORY_FOOD: 5,  // 食品
  CARD_CATEGORY_LABOR: 6, // 劳保
  CARD_CATEGORY_FURNITURE: 7, // 家居
  CARD_CATEGORY_KITCHEN: 8, // 餐厨
  CARD_CATEGORY_CAKE: 9, // 蛋糕
  CARD_CATEGORY_GIFT: 10, // 礼包
  CARD_CATEGORY_PICKING_VOUCHER: 11, // 提货券
  CARD_CATEGORY_GIFT_VOUCHER: 12, // 档位券
  CARD_CATEGORY_CAKE_B: 13, // 蛋糕B卡
  CARD_CATEGORY_CAKE_PLUS: 18, // 蛋糕plus
  CARD_CATEGORY_ALL: 10000, // 商城通
  CARD_CATEGORY_MULTIPLE: 10001, // 多品类
  CARD_CATEGORY_SUPER: 10002, // 超级卡
  CARD_CATEGORY_SUPER_CAKE: 10003, // 蛋糕超级券
  TICKET_CARD_TYPE_COUNT: 1, // 电影次卡
  TICKET_CARD_TYPE_CATEGORY: 2, // 电影品类卡，商城通

  // 新增
  // CARD_CATEGORY_LITONG: 17, // (原来灵通券是17已弃用， 改用29)
  CARD_CATEGORY_LITONG: 29, // 提货券（原灵通券）
  CARD_CATEGORY_EXPERIENCE: 19,  // 体检券
  CARD_CATEGORY_EXPERIENCE_PLUS: 20, // 体检券Plus

  CARD_CATEGORY_SUDA: 23, // 电影视频券

  CARD_CATEGORY_CUSTOM: 32, // 定制卡券

  CARD_GROUP_CONSTRUCTION: 33, // 团建券
  CARD_TIME_TICKRT: 10007, // 定制次票券

  CARD_PICKUP_GOODS_NOT: 0, // 非提货券(普通商城通卡)

  CARD_CATEGORY_PICKING_VOUCHER_NAME: '提货券专区', // 提货券
  CARD_CATEGORY_GIFT_VOUCHER_NAME: '档位券专区', // 档位券

  // 卡 业务类型，1：消费、4：退款，5：充值，6：扣减（2、3类型订单不返回）
  CARD_BUSSNESS_TYPE_CONSUME: 1, // 消费
  CARD_BUSSNESS_TYPE_REFUND: 4, // 退款
  CARD_BUSSNESS_TYPE_RECHARGE: 5, // 充值
  CARD_BUSSNESS_TYPE_DEDUCTION: 6, // 扣减

  // 卡类型：1 -- 次票券 2 -- 品类券 3 -- 档位券
  CARD_TYPE_CI_PIAO: 1, // 次票券
  CARD_TYPE_PIN_LEI: 2, // 品类券
  CARD_TYPE_DANG_WEI: 3, // 档位券
  SOURCEFORM_TMBD: 'tmBd', // 团建小程序

}, km({
  CINEMA_GET_INFO_SUCCESS: null,
  CINEMA_GET_INFO_ERROR: null,
  CARD_GETCARDDETAIL_SUCCESS: null,
  CARD_GETCARDDETAIL_ERROR: null,
  CARD_CARDBINDING_SUCCESS: null,
  CARD_CARDBINDING_ERROR: null,
  CARD_CARDBINDING_NOTICE: null,
  CARD_CARDRENEW_SUCCESS: null,
  CARD_CARDRENEW_ERROR: null,
  CARD_CARDRENEW_V2_SUCCESS: null,
  CARD_CARDRENEW_V2_ERROR: null,
  CARD_GETCARDTOKEN_SUCCESS: null,
  CARD_GETCARDTOKEN_ERROR: null,
  CARD_REMOVECARDBINDING_SUCCESS: null,
  CARD_REMOVECARDBINDING_ERROR: null,
  CARD_GETCARDPASSWORD_SUCCESS: null,
  CARD_GETCARDPASSWORD_ERROR: null,
  CARD_GETUSEFULCARDS_SUCCESS: null,
  CARD_GETUSEFULCARDS_ERROR: null,
  CARD_GETUSELESSCARDS_SUCCESS: null,
  CARD_GETUSELESSCARDS_ERROR: null,
  CARD_GETLIMITCITY_SUCCESS: null,
  CARD_GETLIMITCITY_ERROR: null,
  CARD_GETLIMITCINEMA_SUCCESS: null,
  CARD_RESETLIMITCINEMA: null,
  CARD_GETLIMITCINEMA_ERROR: null,

  CARD_CINEMACHANGE_TEXT: null,
  CARD_GET_CINEMAHISTORY_START: null,
  CARD_GET_CINEMAHISTORY_SUCCESS: null,
  CARD_GET_CINEMAHISTORY_ERROR: null,
  CARD_SET_CINEMAHISTORY_START: null,
  CARD_SET_CINEMAHISTORY_SUCCESS: null,
  CARD_SET_CINEMAHISTORY_ERROR: null,
  CARD_CLEAR_CINEMAHISTORY_START: null,
  CARD_CLEAR_CINEMAHISTORY_SUCCESS: null,
  CARD_CLEAR_CINEMAHISTORY_ERROR: null,
  CARD_REMOVE_CINEMAHISTORY_START: null,
  CARD_REMOVE_CINEMAHISTORY_SUCCESS: null,
  CARD_REMOVE_CINEMAHISTORY_ERROR: null,
  CARD_GETCARDBANNER_SUCCESS: null,
  CARD_GETCARDBANNER_ERROR: null,

  CARD_GETCARDCONSUME_SUCCESS: null,
  CARD_GETCARDCONSUME_ERROR: null,

  CARD_GETCARDBILLLIST_SUCCESS: null,
  CARD_GETCARDBILLLIST_ERROR: null,

  CITY_SET_GPS_POSITION: null, // gps定位相关

  SOURCEFORM_TMBD: 'h5', // 团建小程序
  CARD_GETPINPAILIST_SUCCESS: null,
  CARD_GETPINPAILIST_ERROR: null,

  CARD_GETBILLLISTSHOP_SUCCESS: null,
  CARD_GETBILLLISTSHOP_ERROR: null

  /* yeoman-template-point-1 */
}))
